<div class="productTags">
  <ng-container *ngIf="isDealsActive; else regularTags">
    <span
      class="productTags__tag productTags__tag--deal"
      [ngStyle]="{color: currentDeal?.textColor, 'background-color': currentDeal?.backgroundColor}"
    >
      {{ currentDeal.localizedName }}
    </span>
  </ng-container>
  <ng-template #regularTags>
    <span *ngFor="let tag of tags" class="productTags__tag">
      <span *ngIf="tag === 'welove'">We Love</span>
      <span *ngIf="tag === 'vintage'">Vintage</span>
    </span>
  </ng-template>
</div>
